/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// customize and extend default settings affecting the browser, using Gatsby’s browser APIs
import '../bitsploit/node_modules/bootstrap/dist/css/bootstrap.min.css'

//require("prismjs/themes/prism-okaidia-modified.css")
require("prismjs/plugins/line-numbers/prism-line-numbers.css")